import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import PretendardText from "./../../../component/atoms/text/mainText";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import DatePicker from "../_components/datePicker";
import Modal from "../../../component/templates/Modal";
import TableText from "./../../../component/atoms/text/table/tableText";
import { formatNumberWithCommas } from "./../../../util/formatNumber";

const StatisticsInflowSite = () => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const [selectedStartDate, setSelectedStartDate] = useState("");

  const [selectedEndDate, setSelectedEndDate] = useState("");

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");

  useEffect(() => {
    if (selectedStartDate === "" && selectedEndDate !== "") {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("시작 날짜를 선택해주세요.");
      setSelectedStartDate("");
      setSelectedEndDate("");
    }

    if (selectedEndDate !== "" && selectedStartDate > selectedEndDate) {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("끝 날짜가 시작 날짜보다 빠를 수 없습니다.");
      setSelectedEndDate("");
    }
  }, [selectedStartDate, selectedEndDate]);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 16,
            }}
          >
            유입 사이트
          </TableTitle>
          <PretendardText
            style={{
              fontWeight: "500",
              fontSize: "13px",
              lineHeight: "18.75px",
              letterSpacing: "-0.3%",
              color: "#aaa",
              marginBottom: 30,
            }}
          >
            어떤 도메인과 URL에서 내 사이트에 방문했는지 표시합니다.
            <br />
            Google 검색결과에서 유입되는 URL은 집계되지 않습니다. (유입 후
            추적하지 못하도록 Referer를 제거)
          </PretendardText>
          <ContentContainer>
            <ContentHeader>
              <DatePicker
                popupIsOpen={popupIsOpen}
                onClick={() => {
                  setPopupIsOpen(!popupIsOpen);
                }}
                startDate={selectedStartDate}
                startDateHandler={(date) => {
                  setSelectedStartDate(date);
                }}
                endDate={selectedEndDate}
                endDateHandler={(date) => {
                  setSelectedEndDate(date);
                }}
                footerBtnHandler={() => {}}
              />
              {/* <ExcelBtn /> */}
            </ContentHeader>
            <div
              style={{
                width: "100%",
                display: "flex",
                gap: 26,
              }}
            >
              {/* ********** 유입 도메인 ********** */}
              <TableContainer
                style={{
                  width: 431,
                }}
              >
                <TableHeader>
                  <TableHeaderText>유입 도메인</TableHeaderText>
                </TableHeader>
                <table
                  style={{
                    width: "100%",
                    borderSpacing: 0,
                    borderCollapse: "collapse",
                  }}
                >
                  <colgroup>
                    {/* 합계: 431px */}
                    {/* 도메인 */}
                    <col width="318px" />
                    {/* 클릭수 */}
                    <col width="113px" />
                  </colgroup>
                  <thead>
                    <tr
                      style={{
                        height: 41,
                        backgroundColor: "#313233",
                        borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            paddingLeft: 24,
                          }}
                        >
                          도메인
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                            marginRight: 24,
                          }}
                        >
                          클릭수
                        </TableText>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(8)].map((_, index) => {
                      return (
                        <>
                          <tr
                            key={index}
                            style={{
                              height: 59,
                              borderTop:
                                index === 0
                                  ? "none"
                                  : "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <td>
                              <TableText
                                style={{
                                  maxWidth: 294,
                                  paddingLeft: 24,
                                }}
                              >
                                www.naver.com
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                  marginRight: 24,
                                }}
                              >
                                {formatNumberWithCommas(2000)}
                              </TableText>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </TableContainer>

              {/* ********** 유입 URL ********** */}
              <TableContainer
                style={{
                  width: 587,
                }}
              >
                <TableHeader>
                  <TableHeaderText>유입 URL</TableHeaderText>
                </TableHeader>
                <table
                  style={{
                    width: "100%",
                    borderSpacing: 0,
                    borderCollapse: "collapse",
                  }}
                >
                  <colgroup>
                    {/* 합계: 587px */}
                    {/* 도메인 */}
                    <col width="459px" />
                    {/* 클릭수 */}
                    <col width="128px" />
                  </colgroup>
                  <thead>
                    <tr
                      style={{
                        height: 41,
                        backgroundColor: "#313233",
                        borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            paddingLeft: 24,
                          }}
                        >
                          도메인
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                            marginRight: 24,
                          }}
                        >
                          클릭수
                        </TableText>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(5)].map((_, index) => {
                      return (
                        <>
                          <tr
                            key={index}
                            style={{
                              height: 59,
                              borderTop:
                                index === 0
                                  ? "none"
                                  : "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <td>
                              <TableText
                                style={{
                                  maxWidth: 435,
                                  paddingLeft: 24,
                                }}
                              >
                                https://jedipitstore.kr/pdf_lecture_script/
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                  marginRight: 24,
                                }}
                              >
                                {formatNumberWithCommas(2000)}
                              </TableText>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </TableContainer>
            </div>
          </ContentContainer>
        </DetailPageLayout>
      </MainLayout>

      {modalIsOpen && (
        <Modal
          type="alert"
          title={modalTitle}
          text={modalText}
          setModalOpen={setModalIsOpen}
          onClick={() => {
            setModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

export default StatisticsInflowSite;

const ContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TableContainer = styled.div.attrs((props) => {})`
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
`;

const TableHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

const TableHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;
